var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0C15.68 0 0 15.68 0 35s15.68 35 35 35 35-15.68 35-35S54.32 0 35 0zm3.5 52.5h-7v-7h7v7zm0-14h-7v-21h7v21z",
    fill: "#F2C94C"
  })));
}
export default __webpack_public_path__ + "static/media/warning.26aef30c.svg";
export { SvgWarning as ReactComponent };